// test1252
(1252 && 0);
